import { useCallback, useEffect, useState } from "react";
import type { UseAddressToggleProps, UseAddressToggleReturn } from "../types";

export const useAddressToggle = ({
	initialShowStart = false,
	initialShowFinal = false,
}: UseAddressToggleProps = {}): UseAddressToggleReturn => {
	const [showStart, setShowStart] = useState(initialShowStart);
	const [showFinal, setShowFinal] = useState(initialShowFinal);

	useEffect(() => {
		setShowStart(initialShowStart);
	}, [initialShowStart]);

	useEffect(() => {
		setShowFinal(initialShowFinal);
	}, [initialShowFinal]);

	const toggleStart = useCallback(
		(onOpen?: () => void) => {
			const nextValue = !showStart;
			setShowStart(nextValue);
			if (nextValue) {
				onOpen?.();
			}
		},
		[showStart]
	);

	const toggleFinal = useCallback(
		(onOpen?: () => void) => {
			const nextValue = !showFinal;
			setShowFinal(nextValue);
			if (nextValue) {
				onOpen?.();
			}
		},
		[showFinal]
	);

	return { showStart, showFinal, toggleStart, toggleFinal };
};
